import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountApiService, AppService } from '@mavles/user';
import { StaticDataService } from '@mavles/shared';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  errorMessage = '';
  formSubmitted = false;
  redirectURL!: string;

  private route = inject(ActivatedRoute);
  private fb = inject(FormBuilder);
  private router = inject(Router);
  private appService = inject(AppService);
  public accountService = inject(AccountApiService);
  private staticDataService = inject(StaticDataService);

  constructor() {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    const params = this.route.snapshot.queryParams;
    if (params['redirectURL']) {
      this.redirectURL = params['redirectURL'];
    }
  }

  onLogin() {
    if (this.loginForm.invalid) return;

    this.errorMessage = '';
    const { email, password } = this.loginForm.value;

    this.accountService.login(email, password).subscribe({
      next: (res) => {
        this.appService.signIn(res.data);
        this.staticDataService.loadData();
        const url = this.redirectURL || '/';
        this.router.navigate([url]);
      },
      error: (err) => {
        this.handleLoginError(err);
      },
    });
  }

  private handleLoginError(error: any) {
    console.error('Login error:', error);

    if (error.status === 401) {
      this.errorMessage = 'Invalid email or password.';
    } else if (error.error?.message) {
      this.errorMessage = error.error.message;
    } else {
      this.errorMessage = 'An unexpected error occurred.';
    }

    // Trigger shake animation via simple class toggle timeout if needed,
    // or better yet rely on the errorMessage presence in template.
    // The template uses [ngClass]="{ shake: errorMessage !== '' }"
    // So setting errorMessage triggers it.

    // Auto-clear after 5 seconds
    setTimeout(() => {
      this.errorMessage = '';
    }, 5000);
  }

  validate(): boolean {
    return this.formSubmitted && this.loginForm.invalid;
  }
}


